// extracted by mini-css-extract-plugin
export default {"box":"NumericBox_box__HH4xY","contained":"NumericBox_contained__3pIA7","outlined":"NumericBox_outlined__6T6pz"};